const brand = [
  {
    display: "Nike",
    brandSlug: "Nike",
  },
  {
    display: "Adidas",
    brandSlug: "Adidas",
  },
  {
    display: "Jordan",
    brandSlug: "Jordan",
  },
  {
    display: "Off-White",
    brandSlug: "Off-White",
  },
  {
    display: "Versace",
    brandSlug: "Versace",
  },
];

export default brand;
